/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default () => ({
    //map result
    //first one is resolved postal address
    //second one is coord [lat, lon] of the selected point
    postalAddress: null,
    location: null,

    //Instance of LocationService
    resolver: null,

    //Used to show places from postal address
    locationsResult:[],

    //map config
    config: {
        type: null,
        zoom: 11,
        center: null,
        poisConfig:null,
        cityRestrictConfig:null,
    },

    //map points and polygons
    pois: [],

    //map restriction
    cities: [],
    options: {
        invert: true
    },
});
